module.exports = __webpack_public_path__ + "img/1_atm_l1_l2_lr_l0.f2c2547d.png";